import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const Enrolled: FunctionComponent<IconProps> = ({
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg xmlns="http://www.w3.org/2000/svg" width="46" height="35" viewBox="0 0 46 35" fill="none">
      <path
        d="M21.7364 0.193623C22.3098 -0.0689746 22.9701 -0.0645107 23.5391 0.207295L43.1798 9.60183C44.0405 10.0136 44.4388 10.8617 44.379 11.68V21.5178C45.3346 21.9452 46.002 22.9033 46.002 24.0178C46.0018 25.53 44.774 26.7561 43.2618 26.7561C41.75 26.7556 40.5237 25.5297 40.5235 24.0178C40.5235 22.8636 41.2395 21.8777 42.2501 21.4749V13.9026L38.3868 15.8323V25.4768C38.3864 27.9966 36.7383 30.2199 34.3282 30.9553L24.3614 33.9964C23.2316 34.3409 22.0225 34.3281 20.9005 33.9592L10.7305 30.6155C8.37979 29.8424 6.79108 27.6468 6.79108 25.1721V16.1096L1.20905 13.4397C-0.417422 12.661 -0.398838 10.3379 1.2403 9.5862L21.7364 0.193623ZM23.5723 23.2307C23.0587 23.4872 22.4663 23.5246 21.9298 23.3401L21.7032 23.2483L9.7403 17.5217V25.1721C9.7403 26.3731 10.5115 27.4376 11.6524 27.8128L21.8223 31.1565C22.3668 31.3354 22.9539 31.3432 23.502 31.176L33.4688 28.135C34.638 27.778 35.4372 26.6993 35.4376 25.4768V17.305L23.5723 23.2307ZM4.13093 11.5354L22.6133 20.3811L40.3223 11.5374L22.6114 3.06667L4.13093 11.5354Z"
        fill="#327EA5"
      />
    </svg>
  </IconWrapper>
);
